import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=82d628a0&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=ts"
export * from "./Roles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d628a0",
  null
  
)

export default component.exports